<template>
  <!-- git 仓库初始化配置 -->
  <div>
    <!-- footer -->
    <div class="footer">
      <div class="left" v-for="(list,index) in lists" :key="index">
       <p class="link">友情链接 : 
          <!-- <img @click="golink(item.url)" v-for="(item,index) in ylists" :key="index" :src="item.image" alt="">  -->
          <span  @click="golink(item.url)" v-for="(item,index) in ylists" :key="index">{{item.name}}</span>
        </p>
        <div>{{list.copyright}}</div>
        <p> &copy;  {{list.record}}</p>
        <p>地址：{{list.address}} &nbsp; &nbsp; 邮箱：{{list.email}} &nbsp; &nbsp; 客服电话：{{list.service}}</p>
      </div>
      <div class="right">
        <div>
            <p>微信公众号</p> <img src="../assets/img/3333.jpeg" alt="">&nbsp;&nbsp;
        </div>
        <div>
            <p>APP下载</p> <img src="../assets/img/5555.jpg" alt="">
        </div>
      </div>
      <div class="right">
        <span @click="goxy(4)">免责声明</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <span @click="backtop">回到顶部</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "footer",
  data() {
    return {
      lists: [],
      ylists:[],
    };
  },
  methods: {
    // footer
    async about() {
      await this.$service.home
        .about({})
        .then(res => {
          // console.log(res.data.content)
          if (res.data.code == 200) {
            this.lists.push(res.data.content);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    
     async blogroll() {
      await this.$service.home
        .blogroll({})
        .then(res => {
          console.log(res.data.content)
          if (res.data.code == 200) {
            this.ylists = res.data.content
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    goxy(i) {
      this.$router.push({
        path: "/xy",
        query: {
          id: i
        }
      });
    },
    golink(url){
      window.location.href=url;
    },
    // 显示回到顶部按钮
    showbtn() {
      let that = this;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      that.scrollTop = scrollTop;
    },
    /**
     * 回到顶部功能实现过程：
     * 1. 获取页面当前距离顶部的滚动距离（虽然IE不常用了，但还是需要考虑一下兼容性的）
     * 2. 计算出每次向上移动的距离，用负的滚动距离除以5，因为滚动的距离是一个正数，想向上移动就是做一个减法
     * 3. 用当前距离加上计算出的距离，然后赋值给当前距离，就可以达到向上移动的效果
     * 4. 最后记得在移动到顶部时，清除定时器
     */
    backtop() {
      var timer = setInterval(function() {
        let osTop =
          document.documentElement.scrollTop || document.body.scrollTop;
        let ispeed = Math.floor(-osTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          osTop + ispeed;
        this.isTop = true;
        if (osTop === 0) {
          clearInterval(timer);
        }
      }, 30);
    }
  },
  mounted() {
    this.about();
    window.addEventListener("scroll", this.showbtn, true);
    this.blogroll()
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.footer {
  min-height: 160px;
  background: rgba(43, 44, 63, 1);
  display: flex;
  justify-content: space-around;
  font-size: 14px;
  color: #FFFFFF;
}
.footer .left {
  margin-top: 10px;
}
.footer .right {
  color: rgba(54, 152, 255, 1);
  /* margin-top: 45px; */
  display: flex;
  align-items: center;
  text-align: center;
}
.footer .right div{
  margin-left: 30px;
}
.footer .right p{
  color: #fff;
}
.footer .right  img{
  width: 120px;
  height: 120px;
}
.footer .link{
  display: flex;
  align-items: center;
  /* justify-content: space-between; */
}
.footer .link span{
  margin-left: 20px;
}
.footer .link span:hover{
  color: rgba(54, 152, 255, 1);
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue